export function compareByTimestamp<T extends { timestamp: string }>(
	a: T,
	b: T
): number {
	const dA = new Date(a.timestamp);
	const dB = new Date(b.timestamp);
	if (dA > dB) {
		return -1;
	}
	if (dA < dB) {
		return 1;
	}
	return 0;
}

export function compareByTimestampReverse<T extends { timestamp: string }>(
	a: T,
	b: T
): number {
	return -compareByTimestamp(a, b);
}
